'use strict';

import angular from 'angular';
import formTemplate from './form.pug';

const FormDirective = [function() {
  return {
    restrict: 'A',
    template: formTemplate,
    link(scope) {
      // setup formvm - inherit from controller of template using directive
      var model = scope.$resolve.$$controllerAs || 'vm';
      scope.formvm = scope[model];

      scope.alerts = [];
      scope.closeAlert = function(index) {
        scope.alerts.splice(index, 1);
      };

      // date picker
      scope.dateOpen = {};
      scope.openDatepicker = function($event, value) {
        $event.preventDefault();
        $event.stopPropagation();
        scope.dateOpen[value] = true;
      };

      scope.submitted = false;
      scope.submitForm = function(form) {
        scope.submitted = true;

        var errorCb = function(err) {
          scope.submitted = true;
          // Update validity of form inputs with server/database errors
          if(err && err.data && err.data.errors) {
            if(!scope.errors) { scope.errors = {}; }
            var errors = err.data.errors;
            angular.forEach(errors, function(error, input) {
              if(input === 'emails') { input = 'email'; }
              form[input].$setValidity('database', false);
              scope.errors[input] = error.message;
            });
          }
        };

        if(form.$valid) {
          // set to false if form is reused, reset in errorCb
          scope.submitted = false;
          scope.formvm.submit().catch(errorCb);
        }
      };
    }
  };
}];

export default FormDirective;
